import { api, 
  getWithOptionalAuthorization, 
  putWithOptionalAuthorization, 
  postWithOptionalAuthorization,
  deleteWithOptionalAuthorization,
  patchWithOptionalAuthorization } from './api';
import { SUBSECTION_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';


export type SubSectionParams = {
    ID?: string;
    SectionID: string;
    Name: string;
    SubSectionFile: File;
    Description: string;
};

export type SubSectionResponse = {
    id: string;
    sectionID: string;
    name: string;
    fileUrl: File;
    fileName: string;
    description: string;
    createdAt: string;
};

export type SubSectionDescriptionPatchBody = {
    id: string;
    description: string;
};

const getSubSectionFormData = (params: SubSectionParams): FormData => {

    const formData = new FormData();
    if (params.ID) {
        formData.append('ID', params.ID);
    }
    formData.append('SectionID', params.SectionID);
    formData.append('Name', params.Name);
    formData.append('SubSectionFile', params.SubSectionFile);
    formData.append('Description', params.Description);

    return formData;
};

const subSectionApi = {

  getSubSection : async (sectionId: string): Promise<any> => {
    try {
      const encryptedSubSectionResponse = await getWithOptionalAuthorization(`${SUBSECTION_BASE}/${sectionId}`, true);
      const subSectionResponse = decryptMessage(encryptedSubSectionResponse.data.Data, getToken());
      return subSectionResponse;
    } catch (error) {
      console.error('Error fetching get sub section:', error);
      throw error;
    }
  },

  postSubSection: async (params: SubSectionParams) => {

    const body = getSubSectionFormData(params);
    const encryptedPostResponse = await postWithOptionalAuthorization(`${SUBSECTION_BASE}`, body, true, true);
    const postResponse = decryptMessage(encryptedPostResponse.data.Data, getToken());
    return postResponse;
  },

  putSubSection: async (params: SubSectionParams) => {
    const body = getSubSectionFormData(params);
    const encryptedPutResponse = await putWithOptionalAuthorization(`${SUBSECTION_BASE}`, body, true, true);
    const putResponse = decryptMessage(encryptedPutResponse.data.Data, getToken());
    return putResponse;
  },

  deleteSubSection: async (subSectionId: string) => {
    const response = await deleteWithOptionalAuthorization(`${SUBSECTION_BASE}/${subSectionId}`, true);
    return response;
  },

  patchSubSectionDescription: async (body: SubSectionDescriptionPatchBody) => {
    const response = await patchWithOptionalAuthorization(`${SUBSECTION_BASE}/Description`, body, true);
    return response;
  }
};

export default subSectionApi;